import { useUserBaseUrl } from '@cosuno/authentication-frontend';

import NavigateWithParams from '../NavigateWithParams';

const RedirectToBaseUrl = () => {
  const userBaseUrl = useUserBaseUrl();

  return <NavigateWithParams to={userBaseUrl} />;
};

export default RedirectToBaseUrl;
